import styled from 'styled-components';

const colorAndLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-right: 1rem;
`;

const Wrapper = {
  ColorAndLabel: colorAndLabel,
};

export default Wrapper;
